import { Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { TypesHelper } from '../library/types-helper';

export class CustomValidators {

   static requiredStringTrimmed(ctrl: AbstractControl): ValidationErrors | null {
      if (!ctrl) {return null; }
      const str: string = ctrl.value;
      if (str.trim().length > 0) {
         return null;
      }
      return {'Empty value': true};
   }

   static requiredInteger(ctrl: AbstractControl): ValidationErrors | null {
      if (!ctrl) {return null; }

      if (TypesHelper.isInteger10(ctrl.value)) {
         return null;
      }

      return {'Not an Integer value': true};
   }

   static requiredNumber(ctrl: AbstractControl): ValidationErrors | null {
      if (!ctrl) {return null; }

      if (TypesHelper.isNumber(ctrl.value)) {
         return null;
      }

      return {'Not an Number value': true};
   }
}




// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/ng/custom-validators.ts